function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Cookify = /*#__PURE__*/function () {
  function Cookify() {
    var _this = this;

    var dataName = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'cookify';
    var actionCallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function () {};
    var trackingCallback = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};
    var saveWithChange = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
    var saveByDefault = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
    var cookieDefault = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'necessary';

    _classCallCheck(this, Cookify);

    this.onCheckboxClick = function (e) {
      var type = e.target.getAttribute(_this.getQueryData('check')),
          checkboxElements = document.querySelectorAll('input' + _this.getQueryDataBrackets('check', type)),
          cookieState = _this.getDataState(type);

      cookieState = _this.changeDataState(type, !cookieState);
      _this.saveWithChange && (cookieState ? _this.changeScriptType(type, 'js') : _this.changeScriptType(type, 'plain'));

      var _iterator = _createForOfIteratorHelper(checkboxElements),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var checkboxElement = _step.value;
          cookieState ? checkboxElement.checked = 'checked' : checkboxElement.checked = false;
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    };

    this.onActionAcceptClick = function () {
      for (var type in _this.data) {
        if (type != _this.viewedName) {
          _this.data[type] ? _this.changeScriptType(type, 'js') : _this.changeScriptType(type, 'plain');
        }
      }

      _this.data[_this.viewedName] = true;

      _this.setMemoryData(_this.data);

      _this.actionCallback();
    };

    this.onActionNecessaryClick = function () {
      // Nur notwendig auf true
      for (var type in _this.data) {
        if (type != _this.cookieDefault && type != _this.viewedName) {
          _this.data[type] = false;

          _this.changeScriptType(type, 'plain');

          var checkboxElements = document.querySelectorAll('input' + _this.getQueryDataBrackets('check', type));

          var _iterator2 = _createForOfIteratorHelper(checkboxElements),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var checkboxElement = _step2.value;
              checkboxElement.checked = false;
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
        }
      }

      _this.data[_this.viewedName] = true;

      _this.setMemoryData(_this.data);

      _this.actionCallback();
    };

    this.onActionAllClick = function () {
      for (var type in _this.data) {
        _this.data[type] = true;

        if (type != _this.viewedName) {
          _this.changeScriptType(type, 'js');

          var checkboxElements = document.querySelectorAll('input' + _this.getQueryDataBrackets('check', type));

          var _iterator3 = _createForOfIteratorHelper(checkboxElements),
              _step3;

          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var checkboxElement = _step3.value;
              checkboxElement.checked = 'checked';
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
        }
      }

      _this.setMemoryData(_this.data);

      _this.actionCallback();
    };

    this.dataName = dataName;
    this.data = new Object();
    this.query = 'data-c-';
    this.trackingCallback = trackingCallback;
    this.saveByDefault = saveByDefault;
    this.saveWithChange = saveWithChange;
    this.cookieDefault = cookieDefault;
    this.viewedName = 'viewed';
    this.actionCallback = actionCallback;
    this.init();
  }

  _createClass(Cookify, [{
    key: "init",
    value: function init() {
      this.initData();
      this.initCheckboxes();
      this.initListeners();
    }
    /**
     * Check the data for integrity
     */

  }, {
    key: "initData",
    value: function initData() {
      if (!this.getMemoryData()) {
        var typeElements = document.querySelectorAll('input' + this.getQueryDataBrackets('check'));

        var _iterator4 = _createForOfIteratorHelper(typeElements),
            _step4;

        try {
          for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
            var typeElement = _step4.value;

            if (typeElement.getAttribute(this.getQueryData('check')) == this.cookieDefault || typeElement.getAttribute(this.getQueryData('check-default')) == 'true') {
              this.data[typeElement.getAttribute(this.getQueryData('check'))] = true;
            } else {
              this.data[typeElement.getAttribute(this.getQueryData('check'))] = false;
            }
          }
        } catch (err) {
          _iterator4.e(err);
        } finally {
          _iterator4.f();
        }

        this.data[this.viewedName] = false;
        this.saveByDefault ? this.setMemoryData(this.data) : null;
      } else {
        this.data = this.getMemoryData();
      }
    }
    /**
     * Initialize the checkboxes
     */

  }, {
    key: "initCheckboxes",
    value: function initCheckboxes() {
      var typeElements = document.querySelectorAll('input' + this.getQueryDataBrackets('check')),
          checkChecked = new Array();

      var _iterator5 = _createForOfIteratorHelper(typeElements),
          _step5;

      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var typeElement = _step5.value;
          var type = typeElement.getAttribute(this.getQueryData('check'));

          if (this.getDataState(type)) {
            var checkboxElements = document.querySelectorAll('input' + this.getQueryDataBrackets('check', type));

            var _iterator6 = _createForOfIteratorHelper(checkboxElements),
                _step6;

            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var checkboxElement = _step6.value;
                checkboxElement.checked = 'checked';

                if (type == this.cookieDefault) {
                  checkboxElement.disabled = true;
                }
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }

            !checkChecked[type] && this.changeScriptType(type, 'js');
            checkChecked[type] = true;
          }
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
    }
    /**
     * Initialize the Listeners
     */

  }, {
    key: "initListeners",
    value: function initListeners() {
      // Checkboxes
      var checkboxElements = document.querySelectorAll('input' + this.getQueryDataBrackets('check'));

      var _iterator7 = _createForOfIteratorHelper(checkboxElements),
          _step7;

      try {
        for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
          var checkboxElement = _step7.value;
          checkboxElement.addEventListener('click', this.onCheckboxClick);
        } // Actions

      } catch (err) {
        _iterator7.e(err);
      } finally {
        _iterator7.f();
      }

      var actionElements = document.querySelectorAll(this.getQueryDataBrackets('action'));

      var _iterator8 = _createForOfIteratorHelper(actionElements),
          _step8;

      try {
        for (_iterator8.s(); !(_step8 = _iterator8.n()).done;) {
          var actionElement = _step8.value;

          switch (actionElement.getAttribute(this.getQueryData('action'))) {
            case 'accept':
              actionElement.addEventListener('click', this.onActionAcceptClick);
              break;

            case 'necessary':
              actionElement.addEventListener('click', this.onActionNecessaryClick);
              break;

            case 'all':
              actionElement.addEventListener('click', this.onActionAllClick);
              break;

            default:
              break;
          }
        }
      } catch (err) {
        _iterator8.e(err);
      } finally {
        _iterator8.f();
      }
    }
    /**
     * Get the query name for selecting elements
     * 
     * @param {string} type 
     * @param {string} element 
     * @returns {string}
     */

  }, {
    key: "getQueryData",
    value: function getQueryData(type) {
      var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return element == '' ? "".concat(this.query).concat(type) : "".concat(this.query).concat(type, "=\"").concat(element, "\"");
    }
    /**
     * Get the query name with brackets for selecting elements
     * 
     * @param {string} type 
     * @param {string} element 
     * @returns {string}
     */

  }, {
    key: "getQueryDataBrackets",
    value: function getQueryDataBrackets(type) {
      var element = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      return '[' + this.getQueryData(type, element) + ']';
    }
    /**
     * Read the saved data
     * 
     * @returns data
     */

  }, {
    key: "getMemoryData",
    value: function getMemoryData() {
      // Get from Cookies
      var name = this.dataName + '=',
          ca = document.cookie.split(';');

      for (var i = 0; i < ca.length; i++) {
        var c = ca[i];

        while (c.charAt(0) == ' ') {
          c = c.substring(1);
        }

        if (c.indexOf(name) == 0) {
          return JSON.parse(atob(c.substring(name.length, c.length)));
        }
      }

      return false;
    }
    /**
     * Set the data
     * 
     * @param data
     */

  }, {
    key: "setMemoryData",
    value: function setMemoryData(data) {
      // Callback for tracking user activity
      this.trackingCallback([data, new Date()]); // Verschlüsselung

      data = btoa(JSON.stringify(data)); // Save in cookies

      var date = new Date(),
          expire = 365,
          expires = '';
      date.setTime(date.getTime() + expire * 24 * 60 * 60 * 1000);
      expires = 'expires=' + date.toUTCString();
      document.cookie = this.dataName + '=' + data + ';' + expires + ';path=/;secure';
    }
    /**
     * Get a cookie state
     * 
     * @param {string} type 
     */

  }, {
    key: "getDataState",
    value: function getDataState(type) {
      for (var key in this.data) {
        if (key == type) {
          return this.data[key] === true;
        }
      }

      return false;
    }
    /**
     * Changes the cookie state and saves the data
     * 
     * @param {string} type 
     * @param {boolean} value 
     * @returns {boolean} 
     */

  }, {
    key: "changeDataState",
    value: function changeDataState(type, value) {
      for (var key in this.data) {
        if (key == type) {
          this.data[key] = value;
        }
      }

      this.saveWithChange ? this.setMemoryData(this.data) : null; // Call Event to let the user track activity

      return value;
    }
    /**
     * Any Script type can be changed from text/plain
     * and text/javascript and back
     * 
     * @param {string} script 
     * @param {string} type 
     */

  }, {
    key: "changeScriptType",
    value: function changeScriptType(script, type) {
      var scriptElements = document.querySelectorAll('script' + this.getQueryDataBrackets('script'));

      var _iterator9 = _createForOfIteratorHelper(scriptElements),
          _step9;

      try {
        for (_iterator9.s(); !(_step9 = _iterator9.n()).done;) {
          var scriptElement = _step9.value;

          if (scriptElement.getAttribute(this.getQueryData('script')) == script) {
            if (type == 'js') {
              var reloadScriptElement = document.createElement('script'),
                  parentScriptElement = scriptElement.parentNode;

              for (var key in scriptElement.attributes) {
                if (scriptElement.attributes[key].value) {
                  var attribute = scriptElement.attributes[key];
                  reloadScriptElement.setAttribute(attribute.name, attribute.value);
                }
              }

              reloadScriptElement.setAttribute('type', 'text/javascript');
              reloadScriptElement.innerHTML = scriptElement.innerHTML;
              scriptElement.remove();
              parentScriptElement.appendChild(reloadScriptElement);
            } else {
              scriptElement.setAttribute('type', 'text/plain');
            }
          }
        }
      } catch (err) {
        _iterator9.e(err);
      } finally {
        _iterator9.f();
      }
    }
    /**
     * Event Listeners
     */

    /**
     * Event on mouse click
     * 
     * @param {event} e 
     */

  }]);

  return Cookify;
}();

export { Cookify as default };